<script>
import { mapGetters } from 'vuex'

import Translatable from '@src/mixins/translatable.js'
import Likable from '@src/mixins/likable.js'

export default {
  mixins: [
    Translatable,
    Likable
  ],
  props: {
    attraction: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isFooterExpanded: false
    }
  },
  computed: {
    ...mapGetters('attractions', [
      'likedAttractionsIds'
    ]),
    isFreeEntry() {
      return this.attraction.typology === 'pc_free_entry'
    },
    benefitLabel() {
      return  this.isFreeEntry ? `${this.getTranslatedContent('ATTRACTIONS_label_free_entry') }`:
        this.attraction.typology === 'pc_free' || !this.attraction.typology ?
        `${this.getTranslatedContent('ATTRACTIONS_label_included')} ${this.getTranslatedContent('ATTRACTIONS_label_with_pass')}` :
        `${this.attraction.benefit} ${this.getTranslatedContent('ATTRACTIONS_label_with_pass')}`
    },
    arrOf() {
      return  this.isFreeEntry ? this.freeEntryAttractions
      : this.filteredAttractions
    },
    backgroundImage() {
      const img = this.attraction.images ? this.attraction.images[0] : ''
      return {
        backgroundImage: `url(${process.env.VUE_APP_STATIC_URL}small_${img})`
      }
    },
    backgroundImageLazy() {
      const img = this.attraction.images ? this.attraction.images[0] : ''

      return `${process.env.VUE_APP_STATIC_URL}small_${img}`
    },
    likedClass() {
      return this.likedAttractionsIds.includes(this.attraction._id) ? 'like-btn-active' : 'like-btn-disabled'
    }
  },
  methods: {
    toggle() {
      this.isFooterExpanded = !this.isFooterExpanded
    },
  }
}
</script>

<template>
  <div v-lazy:background-image="backgroundImageLazy" class="card-container">
  <!-- <div :style="backgroundImage" class="card-container"> -->
    <router-link :to="`/attraction/${attraction.slug}`" class="link">
      <div class="card-benefit" :class="isFreeEntry && 'green'">
        <p class="benefit-text">
          {{ benefitLabel }}
        </p>
      </div>
      <div ref="footer"
        :class="isFooterExpanded ? 'card-footer-expanded' : 'card-footer'"
        @mouseenter="toggle"
        @mouseleave="toggle"
      >
        <div class="card-footer-content">
          <p class="attraction-title">
            {{ getTranslatedContent('title', attraction.content) }}
          </p>
          <p v-if="isFooterExpanded" class="attraction-subtitle" v-html="getTranslatedContent('subtitle', attraction.content)">
          </p>
        </div>
        <div
          :class="likedClass"
          @click.prevent="like(attraction._id)"
        >
        </div>
      </div>
    </router-link>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
.card-benefit {
  position: absolute;
  right: 0;
  margin-top: 10px;
  width: auto;
  padding-left: 15px;
  padding-right: 15px;
  height: 23px;
  background: $yellow;
  border-radius: 5px 0 0 5px;

  &.green {
    background: $green;
  }
}

.card-container {
  height: 204px;
  width: 100%;
  background: $dark-gray;
}

.link {
  display: block;
  width: 100%;
  height: 100%;
}

a:focus {
  outline: none;
}

.card-container {
  position: relative;
  border-radius: 10px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.card-footer-mixin {
  position: absolute;
  display: flex;
  align-items: center;
  bottom: 0;
  width: 100%;
  background: rgba(37, 44, 62, 0.6);
  border-radius: 0 0 10px 10px;
}

.card-footer-content {
  display: flex;
  flex-direction: column;
  margin-left: 20px;
}

.card-footer {
  @extend .card-footer-mixin;
  height: 60px;
}

.card-footer-expanded {
  @extend .card-footer-mixin;
  height: 100px;
}

.attraction-title {
  font-family: Open Sans Semibold, sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 14px;
  line-height: 130%;
  text-transform: uppercase;
  color: #FFFFFF;
  margin-bottom: 5px;
  margin-right: 11px;
}

.attraction-subtitle {
  width: 211px;
  height: 48px;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: #FFFFFF;
}

.benefit-text {
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $dark-blue;
}

.like-btn-mixin {
  cursor: pointer;
  min-width: 24px;
  width: 24px;
  height: 24px;
  margin: auto 13px 18px auto;

  z-index: 10;
}

.like-btn-disabled {
  @extend .like-btn-mixin;
  background: url("../assets/icons/heart-disable.svg") center no-repeat;

  &:hover {
    background: url("../assets/icons/heart-active.svg") center no-repeat;
    opacity: 0.8;
  }
}

.like-btn-active {
  @extend .like-btn-mixin;
  background: url("../assets/icons/heart-active.svg") center no-repeat;

  &:hover {
    opacity: 0.8;
  }
}

@media only screen and (max-width: $container-width-xs) {
  .card-footer-mixin {
    border-radius: 0;
  }

  .like-btn-disabled {
    &:hover {
      background: url("../assets/icons/heart-disable.svg") center no-repeat;
    }
  }
}

</style>
